import React from 'react';
import PropTypes from 'prop-types';

const SearchIcon = ({ width, height, ...props }) => (
  <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.8517 14.6347L12.0759 10.859C11.9823 10.7966 11.8887 10.7342 11.7951 10.7342H11.3894C12.3568 9.61083 12.9809 8.11302 12.9809 6.4904C12.9809 2.93311 10.0477 -9.15527e-05 6.49037 -9.15527e-05C2.90188 -9.15527e-05 -0.00012207 2.93311 -0.00012207 6.4904C-0.00012207 10.0789 2.90188 12.9809 6.49037 12.9809C8.11299 12.9809 9.5796 12.388 10.7342 11.4207V11.8263C10.7342 11.9199 10.7654 12.0136 10.8278 12.1072L14.6035 15.8829C14.7595 16.0389 15.0091 16.0389 15.134 15.8829L15.8517 15.1652C16.0077 15.0404 16.0077 14.7907 15.8517 14.6347ZM6.49037 11.4831C3.71319 11.4831 1.49768 9.26758 1.49768 6.4904C1.49768 3.74442 3.71319 1.49771 6.49037 1.49771C9.23635 1.49771 11.4831 3.74442 11.4831 6.4904C11.4831 9.26758 9.23635 11.4831 6.49037 11.4831Z"
      fill="#7c7d74"
    />
  </svg>
);

SearchIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number
};

SearchIcon.defaultProps = {
  width: 14,
  height: 14
};

export default SearchIcon;
